module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAANCAYAAACgu+4kAAAAyklEQVQokZ3QsUpDQRBG4e+awcJKiBDIMygiaGNtbWcRAoLY+Ra+RQr7FFYhhcUldok2gk9gJyGFpTbBxCJ7IQSNrgcWdob9z+5sUZZlD6f+xyBSuI/HzPAuWpGKazxlCpo4C8xwiJdMwTGmgVd00splEqjjBkMUfwzOsY/LwBa6uM+8fQ9X1Sc21xzcxgFqqf7ACA3M4qfUEie4XekF3qrNb9ylFxQWs0/xiZ1lwXiN4B3P3/Qn2KgEbYuZcjjCZmCAc1xkCuZ4+AKKgSQCNWvrDAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/apps/26.png
// module id = 3xOB
// module chunks = 0